// @flow
import env from '../../environment';
import {getCreator, postCreator} from '../../http';

export const endpoints = Object.freeze({
  GET_CURRENCY: `${env.baseApiUrl}/im/admin/currency`,
  GET_CURRENCIES: `${env.baseApiUrl}/im/admin/currency/list`,
  SET_CURRENCY: `${env.baseApiUrl}/im/admin/currency`,
  GET_GEOLOCATION: 'https://ipinfo.io/json',
});

export const getCurrencyApi = getCreator(endpoints.GET_CURRENCY);
export const getCurrenciesApi = getCreator(endpoints.GET_CURRENCIES);
export const setCurrencyApi = postCreator(endpoints.SET_CURRENCY);
export const getGeolocationApi = getCreator(endpoints.GET_GEOLOCATION);
